import { type Table } from '@tanstack/react-table'

import classNames from 'classnames/bind'
import { useEffect } from 'react'
import { TablePagination } from '../TablePagination/TablePagination'

import styles from './DataTablePagination.module.scss'
const cx = classNames.bind(styles)

export interface DataTablePaginationProps<TData> {
  table: Table<TData>
  count?: number
  pageIndex?: number
  pageSize?: number
  pageSizeOptions?: number[]
  onPageChange?: (pageIndex: number) => void
  onPageSizeChange?: (pageSize: number) => void
  isVirtualized?: boolean
}

export const DataTablePagination = <TData, >(props: DataTablePaginationProps<TData>) => {
  const {
    table,
    count,
    pageIndex: pageIndexProp = 0,
    pageSize: pageSizeProp = 10,
    pageSizeOptions,
    onPageChange,
    onPageSizeChange,
    isVirtualized,
  } = props

  useEffect(() => {
    table.setPageSize(pageSizeProp)
    table.setPageIndex(pageIndexProp)
  }, [table, pageSizeProp, pageIndexProp])

  const handlePageChange = (pageIndex: number) => {
    table.setPageIndex(pageIndex)
    onPageChange?.(pageIndex)
  }

  const handlePageSizeChange = (pageSize: number) => {
    table.setPageSize(pageSize)
    onPageSizeChange?.(pageSize)
  }

  const { pageSize, pageIndex } = table.getState().pagination

  return (
    <div className={cx('root', isVirtualized && 'is-virtualized')}>
      <TablePagination
        count={count}
        pageIndex={pageIndex}
        pageSize={pageSize}
        pageSizeOptions={pageSizeOptions}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handlePageSizeChange}
      />
    </div>
  )
}
